import React, { useEffect, useState } from 'react';

import { LETTERS, NUMBERS, SIGNS } from '../../symbols/keys';
import { GameMode } from '../../types';
import { WordListContainer } from '../../wordListContainer';
import { TextField, WordCurrent, WordPrevious } from './components';
import { PreviousWordStateProps } from './stateProps';

const wordListContainer = new WordListContainer();

const getRandomFromArray = (arr: string[]): string => arr[Math.floor(Math.random() * arr.length)];

const getNextChallenge = (mode: GameMode): string | null => {
  switch (mode) {
    case 'letters':
      return getRandomFromArray(LETTERS);
    case 'words':
      return wordListContainer.getRandomWord();
    case 'numbers-signs':
      return getRandomFromArray([...NUMBERS, ...SIGNS]);
    default:
      return null;
  }
};

interface GameProps {
  mode: GameMode;
  onBack: () => void;
}

export const Game = ({ mode, onBack }: GameProps) => {
  const inputRef = React.useRef<null | HTMLInputElement>(null);

  const [currentWord, setCurrentWord] = useState<string | null>(null);
  const [previousWord, setPreviousWord] = useState<PreviousWordStateProps | null>(null);

  useEffect(() => {
    setCurrentWord(getNextChallenge(mode));

    if (!inputRef.current) {
      return;
    }

    inputRef.current.focus();
  }, [mode]);

  const answer = () => {
    if (!inputRef.current || currentWord === null) {
      return;
    }

    const userAnswer = inputRef.current.value.trim();
    inputRef.current.value = '';

    setPreviousWord({
      correct: currentWord,
      answer: userAnswer,
    });
    setCurrentWord(getNextChallenge(mode));
  };

  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex flex-col w-full justify-center mt-8">
        <WordPrevious previousWord={previousWord} />
      </div>
      <div className="flex w-full justify-center mt-4 overflow-x-auto mb-4">
        <WordCurrent word={currentWord} />
      </div>
      {currentWord !== null && (
        <div className="w-full max-w-3xl">
          <TextField inputRef={inputRef} answer={answer} />
        </div>
      )}
      <button className="btn btn-ghost mt-8" onClick={onBack}>
        ← Back to mode selection
      </button>
    </div>
  );
};
